import { createContext } from "react";

const DebtsScreen = createContext<any>(null);

export default DebtsScreen;
